import { Frame } from '@shopify/polaris';
import SuperlemonLogo from '../../assets/images/superlemon-logo_2x.png';
import LoginBanner from '../../assets/images/login-banner-2.png';
import { PROFILE_PAGE } from '../../constants/login-constants';
import { useHistory } from 'react-router-dom';
import CustomForm from '../../common/CustomForm';
import { user_profile } from '../../redux/actions/login';

const Profile = (props: any) => {
  const history = useHistory();

  const handleFormSubmit = async (data: any) => {
    console.log(' data ==> ', data);
    let shop = JSON.parse(localStorage.getItem('shop') || '{}');
    if (shop && shop.id) {
      const res = await user_profile(shop.userId, data);
      if (res?.url) {
        console.log('Profile Information Saved');
        history.push('/home');
      } else {
        // handle error , show popup
      }
    }
  };

  return (
    <Frame>
      <div className='login-container'>
        <div className='login-left'>
          <img
            src={SuperlemonLogo}
            alt='Superlemon Logo'
            className='sl-logo-login'
          />
          <img src={LoginBanner} alt='' className='login-image'></img>
        </div>
        <div className='login-right'>
          <p className='strong fs-2 mt-2 mb-2'>{PROFILE_PAGE.TITLE}</p>
          <p>{PROFILE_PAGE.SUB_TITLE}</p>
          <div className='signin-form'>
            <CustomForm
              handleFormSubmit={handleFormSubmit}
              data={PROFILE_PAGE}
            />
          </div>
        </div>
      </div>
    </Frame>
  );
};

export default Profile;
